import { PUBLIC_DEMO_IDS } from "./catalog.js";
// AI-generated demo portraits. Adjacent names provide the accessible label.
export function portrait(id, size = "small") {
  if (!PUBLIC_DEMO_IDS.includes(id)) return "";
  const large = size === "large";
  return `<img class="demo-portrait" src="/assets/demo-${id}-160-v1.webp" srcset="/assets/demo-${id}-160-v1.webp 160w, /assets/demo-${id}-480-v1.webp 480w" sizes="${large ? "(max-width: 420px) 80vw, (max-width: 1050px) 40vw, 240px" : size === "grid" ? "132px" : "80px"}" width="480" height="480" alt="" loading="lazy" decoding="async">`;
}
